import React from 'react';
import { AboutHero } from '../components/sections/about/AboutHero';
import { FounderStory } from '../components/sections/about/FounderStory';
import { MissionValues } from '../components/sections/about/MissionValues';
import { AboutServices } from '../components/sections/about/AboutServices';
import { Credentials } from '../components/sections/about/Credentials';
import { AboutCta } from '../components/sections/about/AboutCta';
export function About() {
  return <>
      <AboutHero data-id="element-328" data-mp="377dsqds0t3qn" />
      <FounderStory data-id="element-329" data-mp="377xde292268d" />
      <MissionValues data-id="element-330" data-mp="376ciucmqqnai" />
      <AboutServices data-id="element-331" data-mp="376vr11ml9xbc" />
      <Credentials data-id="element-332" data-mp="3751fgdx7jhjx" />
      <AboutCta data-id="element-333" data-mp="2sadad0vpyl4u" />
    </>;
}